const initialState = { data: false };

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'setIsLoading':
            return { data: action.data };
        default:
            return { data: false };
    }
}
export default reducer;